export const QA_NAME_GRETA_AI_CHAT_CODE_BLOCK = 'gretaAIChatCodeBlock'

export const QA_NAME_GRETA_AI_CHAT_CODE_COPY = 'gretaAIChatCodeCopy'
